import React from 'react';
import Icon from '../../../components/AppIcon';

const OrderSummary = ({ orderItems, totals }) => {
  const formatPrice = (price) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    })?.format(price);
  };

  const getItemIcon = (type) => {
    switch (type) {
      case 'ticket':
        return 'Ticket';
      case 'upgrade':
        return 'ArrowUp';
      case 'merchandise':
        return 'ShoppingBag';
      default:
        return 'Package';
    }
  };

  return (
    <div className="bg-card rounded-lg shadow-elevation-2 p-6">
      <h2 className="text-xl font-semibold text-foreground mb-4 flex items-center">
        <Icon name="Receipt" size={20} className="mr-2" />
        Order Summary
      </h2>
      <div className="space-y-4">
        {orderItems?.map((item, index) => (
          <div key={index} className="flex items-center justify-between py-3 border-b border-border last:border-b-0">
            <div className="flex items-center space-x-3">
              <div className="w-8 h-8 bg-muted rounded-full flex items-center justify-center">
                <Icon name={getItemIcon(item?.type)} size={16} className="text-muted-foreground" />
              </div>
              <div>
                <p className="font-medium text-foreground">{item?.name}</p>
                <p className="text-sm text-muted-foreground">
                  {item?.quantity > 1 ? `${item?.quantity}x ` : ''}{item?.description}
                </p>
              </div>
            </div>
            <div className="text-right">
              <p className="font-medium text-foreground">{formatPrice(item?.totalPrice)}</p>
              {item?.quantity > 1 && (
                <p className="text-xs text-muted-foreground">
                  {formatPrice(item?.unitPrice)} each
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 pt-4 border-t border-border space-y-2">
        <div className="flex justify-between text-sm">
          <span className="text-muted-foreground">Subtotal:</span>
          <span className="text-foreground">{formatPrice(totals?.subtotal)}</span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-muted-foreground">Service Fee:</span>
          <span className="text-foreground">{formatPrice(totals?.serviceFee)}</span>
        </div>
        <div className="flex justify-between text-sm">
          <span className="text-muted-foreground">Tax:</span>
          <span className="text-foreground">{formatPrice(totals?.tax)}</span>
        </div>
        <div className="flex justify-between text-lg font-semibold pt-2 border-t border-border">
          <span className="text-foreground">Total:</span>
          <span className="text-foreground">{formatPrice(totals?.total)}</span>
        </div>
      </div>
    </div>
  );
};

export default OrderSummary;